// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"fd57f560","453":"acdc5c78"}[chunkId] + ".chunk.js";
};